<div class="mt-4 space-y-4">
    <div class="card grid grid-cols-2 md:grid-cols-3 2xl:grid-cols-5 gap-4">
        <div class="w-full col-span-full">
            <label class="text-sm">ช่วงเวลาข้อมูล</label>
            <app-select-date-option [selectedOption]="selectedDate"
                (selectOption)="handleOptionSelected($event)"></app-select-date-option>
        </div>
        <div class="w-full">
            <label class="text-sm whitespace-nowrap w-full">กลุ่มช่องการทางขาย</label>
            <div class="w-full">
                <mat-form-field class="w-full">
                    <mat-select multiple [value]="displayedPlatformGroupSelection"
                        (selectionChange)="onPlatformGroupSelectionChange($event.value)"
                        placeholder="เลือกกลุ่มช่องการทางขาย">
                        <mat-option [value]="ALL_GROUP_MARKER">เลือกทั้งหมด</mat-option>
                        @for (channel of platformGroup; track $index) {
                        <mat-option [value]="channel.id">{{channel.name}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="flex justify-start">
            <button class="btn-sm btn-primary w-full md:w-fit self-end" (click)="getDataReport()">ประมวลผล</button>
        </div>
    </div>

    @if(loading){
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <app-loader></app-loader>
            <div class="font-medium">Loading</div>
        </div>
    </div>
    }@else {

    <div class="grid  grid-col-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div class="card">
            <div class="text-sm">คำสั่งซื้อ</div>
            <div class="text-xl font-semibold text-indigo-500">{{summary.totalOrder| number}}</div>
        </div>
        <div class="card">
            <div class="text-sm">ยอดขายสุทธิ</div>
            <div class="text-xl font-semibold text-blue-500">{{summary.totalAmount| number}}</div>
        </div>
        <div class="card">
            <div class="text-sm">ยอดขายเฉลี่ยต่อคำสั่งซื้อ</div>
            <div class="text-xl font-semibold text-green-500">{{summary.avgAmount| number}}</div>
        </div>
    </div>

    <div class="card">
        <div class="grid grid-cols-1">
            <div class="w-full">
                <div class="grid gap-2 md:flex md:space-x-2 items-center justify-between pb-4">
                    <div class="font-medium text-left">ยอดขาย (คำสั่งซื้อ)</div>
                    <div class="flex items-center justify-start">
                        <div class="hidden md:block pr-2 text-sm">การแสดงผล : </div>
                        <mat-form-field class="w-fit !h-9 !text-sm">
                            <mat-select class="!h-9" [value]="displayData"
                                (selectionChange)="displayDataOnchange($event)">
                                <mat-option class="!text-sm" value="total_order">คำสั่งซื้อ</mat-option>
                                <mat-option class="!text-sm" value="total_amount">ยอดขายสุทธิ</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                @if (chartType === 'bar') {
                <div class="mt-4">
                    <app-group-bar-chart [chartId]="'sale1'" [datasets]="barDatasets" [variant]="'single'"
                        [legendTitle]="'กลุ่มช่องการทางขาย'" [scheme]="colorScheme"
                        (select)="onChartBarClick($event)"></app-group-bar-chart>
                </div>
                }
                @if (chartType === 'line') {
                <div class="h-96 pb-28 md:pb-20" *ngIf="!this.loading ">
                    <app-line-chart [chartId]="'sale2'" [datasets]="saleDatasets"
                        [colorScheme]="colorScheme"></app-line-chart>
                </div>
                }

                <div class="mt-6">
                    <div class="text-sm font-semibold text-gray-700 mb-3">รายละเอียดต่อช่องทาง</div>
                    <div class="rounded-xl border border-gray-200 bg-white overflow-hidden divide-y divide-gray-100">
                        @for (group of chartGroups; track group.id) {
                        <div [attr.data-group-row]="group.id">
                            <button type="button"
                                class="w-full flex items-center gap-3 p-4 hover:bg-gray-50 transition-colors text-left"
                                (click)="toggleGroupExpanded(group.id)">
                                <span class="w-3 h-3 rounded-full shrink-0 ring-2 ring-white shadow"
                                    [style.background-color]="group.color || '#32436a'"></span>
                                <div class="font-semibold text-gray-800 flex-1 min-w-0 truncate">{{group.name}}</div>
                                <div class="hidden md:flex items-center gap-6 shrink-0">
                                    <div class="text-right min-w-[6rem]">
                                        <div class="text-[10px] uppercase tracking-wide text-gray-400">คำสั่งซื้อ</div>
                                        <div class="text-sm font-semibold text-gray-700">{{groupTotal(group.id).total_order | number}}</div>
                                    </div>
                                    <div class="text-right min-w-[7rem]">
                                        <div class="text-[10px] uppercase tracking-wide text-gray-400">ยอดขาย (บาท)</div>
                                        <div class="text-sm font-semibold text-gray-700">{{groupTotal(group.id).total_amount | number}}</div>
                                    </div>
                                </div>
                                <fa-icon class="text-gray-400 shrink-0"
                                    [icon]="expandedGroups.has(group.id) ? faChevronDown : faChevronRight"></fa-icon>
                            </button>
                            @if (expandedGroups.has(group.id)) {
                            <div class="bg-gray-50/60 border-t border-gray-100 px-4 py-3">
                                <div class="md:hidden flex justify-between text-xs text-gray-500 mb-3">
                                    <span>{{groupTotal(group.id).total_order | number}} คำสั่งซื้อ</span>
                                    <span>{{groupTotal(group.id).total_amount | number}} บาท</span>
                                </div>
                                @if (groupBreakdown(group.id).length === 0) {
                                <div class="text-sm text-gray-400 py-2 text-center">ไม่มีช่องทางในกลุ่มนี้</div>
                                } @else {
                                <div class="space-y-3">
                                    @for (channel of groupBreakdown(group.id); track channel.name) {
                                    <div>
                                        <div class="flex items-center justify-between gap-3 mb-1">
                                            <span class="text-sm text-gray-700 truncate">{{channel.name}}</span>
                                            <span class="text-sm font-semibold text-gray-800 shrink-0 tabular-nums">
                                                {{(displayData === 'total_order' ? channel.total_order : channel.total_amount) | number}}
                                                <span class="text-xs font-normal text-gray-400 ml-1">{{displayData === 'total_order' ? 'คำสั่งซื้อ' : '฿'}}</span>
                                            </span>
                                        </div>
                                        <div class="w-full h-1.5 bg-gray-200 rounded-full overflow-hidden">
                                            <div class="h-full rounded-full"
                                                [style.width.%]="channelPercent(channel, group.id)"
                                                [style.background-color]="group.color || '#32436a'"></div>
                                        </div>
                                        <div class="flex justify-between text-xs text-gray-500 mt-1">
                                            <span class="tabular-nums">
                                                {{(displayData === 'total_order' ? channel.total_amount : channel.total_order) | number}}
                                                {{displayData === 'total_order' ? '฿' : 'คำสั่งซื้อ'}}
                                            </span>
                                            <span class="tabular-nums">{{channelPercent(channel, group.id) | number:'1.0-1'}}%</span>
                                        </div>
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                            }
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
</div>